var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtractGiveaways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3626 9.99967C13.5134 12.7055 10.9858 14.6684 7.99973 14.6684C4.31726 14.6684 1.33203 11.6832 1.33203 8.00071C1.33203 4.31824 4.31726 1.33301 7.99973 1.33301C10.985 1.33301 13.5121 3.29489 14.362 5.99967H13.3041C12.4953 3.85695 10.4255 2.33301 7.99973 2.33301C4.86955 2.33301 2.33203 4.87052 2.33203 8.00071C2.33203 11.1309 4.86955 13.6684 7.99973 13.6684C10.4263 13.6684 12.4967 12.1435 13.3049 9.99967H14.3626Z",
    fill: "#DD6F0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractGiveaways);
export default __webpack_public_path__ + "static/media/subtract-giveaways.fb56b8a44f25e682e74abda2102e00e9.svg";
export { ForwardRef as ReactComponent };